// @flow

export const DOMUS_LOCALE_STORAGE_KEY = 'domus-collapsed'
